import React from 'react';

const Laskutus = ({ data }) => {
  return (
    <div>
      <p>
        Not implemented
      </p>
    </div>
  );
};

export default Laskutus;
